/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';

// Custom "share an idea / feedback" light bulb icon. Radix UI ships no
// lightbulb glyph, so we draw an on-brand monochrome bulb (glass dome + base
// lines) on a 15x15 viewBox to match the rest of the icon set (see
// BuildingIcon).
export const FeedbackIdeaIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="feedback-idea-icon"
    {...props}
  >
    {/* Bulb glass dome */}
    <path
      d="M7.5 1.2C5.15 1.2 3.4 3.0 3.4 5.2C3.4 6.7 4.2 7.75 5.15 8.5C5.7 8.95 6.0 9.5 6.0 10.1H9.0C9.0 9.5 9.3 8.95 9.85 8.5C10.8 7.75 11.6 6.7 11.6 5.2C11.6 3.0 9.85 1.2 7.5 1.2Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    {/* Bulb base / screw lines */}
    <path
      d="M5.9 11.5H9.1M6.4 13.2H8.6"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default FeedbackIdeaIcon;
